import React from 'react'
import images from '../../app/utlis/image'
import Heading from '../atoms/Heading/Heading'
import ProjectDisplay from '../molecules/ProjectDisplay/ProjectDisplay'
import AppsFaq from '../molecules/AppsFaq/AppsFaq'
import AppsRunning from '../molecules/AppsSupportComponents/AppsRunning/AppsRunning'
import ReliabilityWordPressSteps from '../molecules/WordPressComponents/ReliabilityWordPress/ReliabilityWordPressSteps'
import WordPressIdeaProjects from '../molecules/WordPressComponents/WordPressIdeaProjects/WordPressIdeaProjects'
import DefaultFooter from '../organisms/DefaultFooter/DefaultFooter'
import { getPageData, useData } from '../../app/helper/functions'
import { motion } from 'framer-motion'

const WordPress = () => {
    const { data } = useData();
    const wordPressData = getPageData(data, 'wordPressPage');
    
    // Enhanced animations with smoother transitions
    const fadeIn = {
        hidden: { opacity: 0 },
        visible: { 
            opacity: 1,
            transition: { 
                duration: 1,
                ease: [0.25, 0.1, 0.25, 1.0] // Cubic bezier for smoother motion
            }
        }
    };
    
    const slideIn = {
        hidden: { x: -100, opacity: 0 },
        visible: { 
            x: 0, 
            opacity: 1,
            transition: { 
                duration: 0.8, 
                ease: [0.25, 0.1, 0.25, 1.0],
                staggerChildren: 0.1
            }
        }
    };
    
    const slideUp = {
        hidden: { y: 100, opacity: 0 },
        visible: { 
            y: 0, 
            opacity: 1,
            transition: { 
                duration: 0.8, 
                ease: [0.25, 0.1, 0.25, 1.0]
            }
        }
    };
    
    // New scale animation for hover effects
    const scaleOnHover = {
        scale: 1,
        transition: { duration: 0.3 }
    };
    
    return (
        <div>
            <div className='bg-wordpress-bg bg-center bg-cover bg-no-repeat'>
                <div className='bg-blackTransparent'>
                    <div className='flex pr-[10%] pb-8 gap-6 pt-52'>
                        <motion.div 
                            className='w-[90%] bg-[#ffffff12] rounded-r-3xl h-[550px] object-contain flex items-center justify-center'
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: false, amount: 0.2 }}
                            variants={slideIn}
                            whileHover={{ scale: 1.02 }}
                        >
                            <img src={images.WORDPERSSIMAGE} className='z-10 w-[80%] object-fit relative -top-8' />
                        </motion.div>
                        <motion.div 
                            className='text-white flex flex-col gap-2 relative text-end justify-center items-center'
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: false, amount: 0.2 }}
                            variants={fadeIn}
                        >
                            <motion.div 
                                className='font-bold text-6xl mb-2'
                                initial={{ opacity: 0, y: -20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: false, amount: 0.3 }}
                                transition={{ 
                                    duration: 0.7,
                                    ease: [0, 0.71, 0.2, 1.01]
                                }}
                            >
                                {wordPressData.title}
                            </motion.div>
                            <motion.div 
                                className='font-normal text-2xl'
                                initial={{ opacity: 0, y: -20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: false, amount: 0.3 }}
                                transition={{ 
                                    duration: 0.7,
                                    delay: 0.2,
                                    ease: [0, 0.71, 0.2, 1.01]
                                }}
                            >
                                {wordPressData.description}
                            </motion.div>
                        </motion.div>
                    </div>
                </div>
            </div>
            <div className='bg-darkGreyPrimary'>
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.2 }}
                    variants={fadeIn}
                >
                    <Heading className='bg-darkGreyPrimary pt-12'
                        subTitle='Advantages of custom WordPress Development'
                        text="Ready-made software may not meet your specific needs. Custom web application
                        development offers a tailored solution that enhances efficiency, security, and scalability." />
                </motion.div>
                
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.2 }}
                    variants={slideUp}
                >
                    <ReliabilityWordPressSteps wordPressData={wordPressData}/>
                </motion.div>
                
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.2 }}
                    variants={fadeIn}
                >
                    <Heading className='bg-darkGreyPrimary pt-12'
                        subTitle='How we develop WordPress sites' />
                </motion.div>
                
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.2 }}
                    variants={slideUp}
                    transition={{ staggerChildren: 0.3, delayChildren: 0.2 }}
                >
                    <WordPressIdeaProjects wordPressData={wordPressData}/>
                </motion.div>
                
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.2 }}
                    variants={slideUp}
                >
                    <ProjectDisplay />
                </motion.div>
                
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.2 }}
                    variants={fadeIn}
                >
                    <AppsFaq />
                </motion.div>
                
                <motion.div 
                    className='pt-10 bg-darkGreyPrimary'
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.2 }}
                    variants={slideUp}
                    whileHover={{ scale: 1.02 }}
                    transition={{ type: "spring", stiffness: 400, damping: 10 }}
                >
                    <AppsRunning bgImage='bg-confident-programming-bg'
                        title='Get started with your WordPress development today'
                    />
                </motion.div>
                <DefaultFooter />
            </div>
        </div>
    )
}

export default WordPress
